import {type Contact} from 'web-app/react/entities/contacts/types';
import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'EMPLOYEE_PROFILE/EMPLOYEE_CONTACTS';

export const {action: changeSelectedEmployeeContact} = createAction(
    `${domain}/SELECTED_CHANGED`,
    (index: number) => index,
);

export const {action: confirmDeleteEmployeeRelation} = createAction(
    `${domain}/EMPLOYEE_RELATION_DELETE_CONFIRM`,
    (contact: Contact) => ({contact}),
);
